<template>
  <div class="gameCodeDialog">
    <el-dialog
      :visible.sync="showDialog"
      width="70%"
      @close="close"
      title="玩家游戏码"
      v-if="showDialog"
    >
      <!--数据表格-->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        ref="multipleTable"
        height="600"
      >
        <el-table-column
          prop="serialCode"
          label="序列号"
          align="center"
          min-width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.serialCode || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="userId"
          label="用户ID"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.userId || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="merchantId"
          label="商户号"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.merchantId || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="productLevel"
          label="商品等级"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.productLevel || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="productPrice"
          label="商品价格"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.productPrice || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="subscriptionCode"
          label="订单订阅码"
          align="center"
          width="220"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.subscriptionCode || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="创建时间"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ changeTime(scope.row.createdAt) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      uid: undefined, // 用户ID
      showDialog: false,
    };
  },
  methods: {
    // 打开弹窗、传递需要编辑的参数
    open(row) {
      this.uid = row.uid;
      this.showDialog = true;
      this.getList();
    },
    getList() {
      API.queryUserGameCode({ uid: Number(this.uid) })
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 关闭弹窗
    close() {
      this.uid = "";
      this.showDialog = false;
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
.form-flex-box {
  display: flex;
  .el-form-item {
    flex: 1;
  }
}
.tagBox {
  display: inline-block;
  margin-right: 5px;
}
</style>
